import '../scss/layoutElements/form.scss';

export default {
    init(section: HTMLElement) {
        const form = section.querySelector('form');
        const formDiv = section.querySelector('.form-div') as HTMLElement;

        if (!form || !formDiv) return;

        form.addEventListener('onAfterFormieSubmit', () => {
            const downloadButton = section.querySelector('.download-button');

            if (!downloadButton) return;

            downloadButton.classList.remove('hide-btn');
        });
    }
};
